import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "./Login.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import axiosInstance from "../../utils/axiosInstance";
import { encryptFields } from "../../utils/kycStatus";
import { sessionCartApi } from "../../redux/features/cart/sessionCartSlice";
import CustomButton from "../../components/CustomButton";
import { RM } from "../../components/RM";
import { motion, AnimatePresence } from "framer-motion";
import LoginCarousel from "../../components/auth/LoginCarousel";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const redirectTo = location.state?.redirectTo || "/account";

  // console.log("location===============>>>", location);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpdata, setOtpdata] = useState("");
  const [errors, setErrors] = useState("");
  const [step, setStep] = useState(1); // 1: mobile, 2: OTP, 3: RM
  const [direction, setDirection] = useState(1); // 1 for forward, -1 for backward
  const [verifyApiLoading, setVerifyApiLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  const handlePhoneSubmit = async (event) => {
    event.preventDefault();

    const indianPhoneRegex = /^[6-9]\d{9}$/;
    if (phoneNumber === "") {
      setErrors("Mobile number cannot be empty.");
      return;
    } else if (!indianPhoneRegex.test(phoneNumber)) {
      setErrors("Please enter a valid 10-digit Indian mobile number.");
      return;
    } else if (phoneNumber.length !== 10) {
      setErrors("Mobile number must be 10 digits.");
      return;
    } else {
      setErrors("");
    }

    // if (phoneNumber === "9810087627") {
    //   setStep(step + 1);
    //   return;
    // }

    try {
      setVerifyApiLoading(true);
      const response = await axiosInstance.post("/api/auth/sendOtp", {
        phone: phoneNumber,
      });

      if (!response.data.error) {
        toast.success("OTP sent successfully");

        // Decrypt OTP using AES
        // const secretKey = process.env.REACT_APP_OTP_SECRET_KEY;
        // const key = CryptoJS.enc.Hex.parse(secretKey);

        // const encryptedOtp = response?.data?.data[0]?.otp;

        // if (!encryptedOtp || typeof encryptedOtp !== "string") {
        //   throw new Error("Invalid encrypted OTP format received.");
        // }
        // const [ivBase64, encryptedBase64] = encryptedOtp.split(":");
        // const iv = CryptoJS.enc.Base64.parse(ivBase64);
        // const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);
        // // Decrypt the data
        // const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
        //   iv: iv,
        // });

        // const decryptedOtp = decrypted.toString(CryptoJS.enc.Utf8);
        // // console.log("Decrypted OTP:", decryptedOtp);

        // setOtpdata(decryptedOtp);
        if (step === 2) {
          setSeconds(30);
          return;
        }
        setStep(step + 1);
        setSeconds(30);
      }
    } catch (err) {
      console.error("Error connecting to API or decrypting OTP", err);
    } finally {
      setVerifyApiLoading(false);
    }
  };

  const onOtpSubmit = async (otp) => {
    try {
      setOtpLoading(true);
      const response = await axiosInstance.post("/api/auth/customer/login", {
        phone: phoneNumber,
        "otp": otp || null,
        "language": "Englsih"
      });

      if (!response?.data?.error) {
        const rmRes = await getPartnerDetail();

        const { email, dob, name, phone, _id, jwt_token } =
          response?.data?.data?.[0] || {};

        if (email || dob || name || phone || _id) {
          const userDetails = {
            email,
            dob,
            name,
            phone,
            _id,
            pan: false,
            bank: false,
            address: false,
          };

          const fieldsToEncrypt = ["pan", "bank", "address"];

          const encryptedUserDetails = encryptFields(
            userDetails,
            fieldsToEncrypt
          );

          localStorage.setItem(
            "userDetails",
            JSON.stringify(encryptedUserDetails)
          );
        }

        if (jwt_token) {
          sessionStorage.setItem("token", jwt_token);
          sessionStorage.setItem("isLOGIN", jwt_token);
          const sessionCart = JSON.parse(sessionStorage.getItem("cart"));

          if (sessionCart) {
            const payload = { carts: sessionCart };
            dispatch(sessionCartApi(payload));
            sessionStorage.removeItem("cart");
          }

          updateFcmToken(jwt_token);
          if (rmRes) {
            navigate(redirectTo || "/account", { state: location.state });
          }
        } else {
          console.log("Error: JWT token not found in response");
        }
      } else {
        setErrors(response?.data?.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      console.log("Error connecting to API", err);
    } finally {
      setOtpLoading(false);
    }
  };

  const updateFcmToken = async (jwt_token) => {
    try {
      const fcmToken = localStorage.getItem("fcmToken");
      if (!fcmToken) throw new Error("FCM token not found");

      // const url = `${process.env.REACT_APP_BASE_URL}/updateFCM`;
      // const headers = {
      //   "Content-Type": "application/json",
      //   Accept: "application/json",
      //   Authorization: `Bearer ${jwt_token}`, // Add Bearer token here
      // };
      // const reqBody = { fcmToken };

      const res = await axiosInstance.post("/updateFCM", { fcmToken });
    } catch (error) {
      console.log("Error updating FCM token:", error);
    }
  };

  // otp fields code

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, e) => {
    const value = e.target.value;

    // Check if the pasted value contains the entire OTP
    if (value.length === otp.length) {
      const newOtp = value.split("").slice(0, otp.length); // Ensure only the required length is taken
      setOtp(newOtp);

      // Focus on the last field
      if (inputRefs.current[otp.length - 1]) {
        inputRefs.current[otp.length - 1].focus();
      }
      return;
    }

    if (isNaN(value)) return;

    const newOtp = [...otp];
    // Allow only one input
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    // Move to next input if current field is filled and it's not the last input
    if (value && index < otp.length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const combinedOtp = otp.join("");

    if (combinedOtp.length !== 6) {
      setErrors("OTP must be 6 digits.");
      return;
    }

    onOtpSubmit(combinedOtp);

    // if (phoneNumber === "9810087627" && combinedOtp === "123456") {
    //   onOtpSubmit(combinedOtp);
    //   return;
    // }

    // if (combinedOtp === otpdata) {
    //   onOtpSubmit(combinedOtp);
    // } else {
    //   setErrors("Invalid OTP. Please try again.");
    // }
  };

  // useEffect(() => {
  //   if (otp.every((digit) => digit !== "")) {
  //     handleSubmit(); // Automatically submit when all fields are filled
  //   }
  // }, [otp]);

  const handleFocus = (index) => {
    if (inputRefs.current[index]) {
      inputRefs.current[index].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0 && inputRefs.current[index - 1]) {
        // Move focus to the previous input field on backspace
        inputRefs.current[index - 1].focus();
      } else if (index === 0) {
        // Clear all fields if backspace is pressed on the first input field
        setOtp(new Array(6).fill(""));
        inputRefs.current[0].focus();
      }
    }
  };

  const [seconds, setSeconds] = useState(null);

  useEffect(() => {
    if (seconds > 0) {
      const timerId = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timerId);
    }
  }, [seconds]);

  // ==========RM code===================================

  const [rmPartner, setRmPartner] = useState(false);
  const getPartnerDetail = async () => {
    try {
      const response = await axiosInstance.post("/augmont/getRm", {
        phone: phoneNumber || "",
      });

      if (!response.data.error) {
        setRmPartner(true);
        // navigate("/account");
        return true;
      } else {
        setStep(step + 1);
        return false;
      }
    } catch (error) {
      console.error("Error fetching partner details:", error);
    }
  };

  // ============================

  // const getRmDetailsBajaj = async () => {
  //   try {
  //     const response = await axiosInstance.post("/augmont/bajajRmDetails", {
  //       phone: phoneNumber,
  //     });

  //     console.log("RESPONSE===>>>>>>>>", response.data);

  //     if (!response.data.error) {
  //       setRmPartner(true);
  //     } else {
  //       setRmPartner(false);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  return (
    <main className="login_main_container">
      <LoginCarousel />
      <section className="login_form_container">
        <div className="login_form_inner_container">
          <div
            style={{
              position: "relative",
              // overflow: "hidden",
            }}
          >
            <AnimatePresence mode="wait">
              {step === 1 && (
                <motion.div
                  key="step1"
                  custom={direction}
                  initial={{ x: direction > 0 ? 30 : -30, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: direction > 0 ? -30 : 30, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <div>
                    <h5 style={{ fontSize: "28px" }}>Get Started</h5>
                    <h6 style={{ fontSize: "13px", paddingTop: "8px" }}>
                      Enter your mobile number to receive an OTP and log in.
                    </h6>
                    <Form
                      id="demo-form"
                      onSubmit={handlePhoneSubmit}
                      className="formBody text-dark"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "1.6rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          justifyContent: "center",
                          marginBottom: "0.9rem",
                        }}
                      >
                        <Form.Control
                          style={{ width: "20%", border: "1px solid black" }}
                          type="text"
                          value="+(91)"
                          readOnly
                        />

                        <Form.Group controlId="formGroupEmail">
                          <Form.Control
                            type="tel"
                            placeholder="Enter mobile no."
                            value={phoneNumber}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                              if (numericValue.length <= 10) {
                                setPhoneNumber(numericValue);
                              }
                            }}
                            style={{
                              width: "100%",
                              border: "1px solid black",
                            }}
                            maxLength={10}
                          />
                        </Form.Group>
                      </div>
                      {errors && (
                        <div
                          style={{
                            width: "100%",
                            color: "red",
                            fontSize: "0.8rem",
                            display: "flex",
                            marginBottom: "0.5rem",
                          }}
                        >
                          {errors}
                        </div>
                      )}

                      <div style={{ alignItems: "center", fontSize: "0.9rem" }}>
                        By proceeding you accept our{" "}
                        {/* <Link to="/terms-conditions" className="edit_btn"> */}
                        <Link
                          to="https://www.bajajcapital.com/term-conditions?doc=tnc"
                          className="edit_btn"
                        >
                          Terms & Conditions
                        </Link>
                      </div>

                      <div style={{ marginTop: "1.5rem" }}>
                        <CustomButton
                          label="Send OTP"
                          type="submit"
                          loading={verifyApiLoading}
                        />
                      </div>
                    </Form>
                  </div>
                </motion.div>
              )}

              {step === 2 && (
                <motion.div
                  key="step2"
                  custom={direction}
                  initial={{ x: direction > 0 ? 30 : -30, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: direction > 0 ? -30 : 30, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <div>
                    <div className="otp_container">
                      <h5 style={{ fontSize: "28px" }}>OTP Verification</h5>
                      <h6 style={{ fontSize: "13px", paddingTop: "8px" }}>
                        Enter the 6-digit OTP sent to your mobile number.
                      </h6>
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          marginTop: "5px",
                        }}
                      >
                        +91 {phoneNumber || ""}
                        <button
                          onClick={() => {
                            setOtp(Array(6).fill(""));
                            setStep(step - 1)
                          }}
                          className="edit_btn"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                    <form
                      id="demo-form"
                      onSubmit={handleSubmit}
                      style={{ marginTop: "1.6rem" }}
                    >
                      <div className="d-flex mb-2 gap-2">
                        {otp.map((value, index) => (
                          <input
                            key={index}
                            type="tel"
                            autoFocus={index === 0}
                            ref={(input) => (inputRefs.current[index] = input)}
                            value={value}
                            onChange={(e) => handleChange(index, e)}
                            onPaste={(e) => handleChange(index, e)}
                            onClick={() => handleFocus(index)}
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            style={{
                              border: "2px solid black",
                              borderRadius: "5px",
                              width: "50px",
                              height: "50px",
                              textAlign: "center",
                              fontSize: "1.5rem",
                            }}
                          />
                        ))}
                      </div>
                      {errors && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.8rem",
                            margin: "1rem 0",
                            // textAlign: "center",
                          }}
                        >
                          {errors}
                        </div>
                      )}

                      {/* {!(phoneNumber === "9810087627") && ( */}
                      <div
                        style={{
                          width: "100%",
                          margin: "auto",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          fontSize: "12px",
                        }}
                      >
                        {/* <span>Didn't receive code?</span> */}
                        <span>Didn't receive OTP?</span>
                        {seconds <= 0 && (
                          <button
                            type="button"
                            className="edit_btn"
                            disabled={seconds > 0}
                            onClick={handlePhoneSubmit}
                          >
                            Resend OTP
                          </button>
                        )}
                        {seconds > 0 && <div>{seconds} secs</div>}
                      </div>
                      {/* )} */}
                      <div
                        style={{ marginTop: "1.5rem" }}
                        className="d-flex justify-content-center"
                      >
                        <CustomButton
                          label="Submit"
                          type="submit"
                          loading={otpLoading}
                        />
                      </div>
                    </form>
                  </div>
                </motion.div>
              )}
              {step === 3 && (
                <motion.div
                  key="step3"
                  custom={direction}
                  initial={{ x: direction > 0 ? 30 : -30, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: direction > 0 ? -30 : 30, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <RM phoneNumber={phoneNumber} />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
        <div className="login_feature_container">
          <img src="/images/loginFeature1.png" alt="features" width="100%" />
          <img src="/images/loginFeature2.png" alt="features" width="100%" />
          <img src="/images/loginFeature3.png" alt="features" width="100%" />
          <img src="/images/loginFeature4.png" alt="features" width="100%" />
        </div>
      </section>
    </main>
  );
};

export default Login;
